import { useProduct, useProductsWithHoldings } from 'hooks/products/useProducts';
import { useGetProfileQuery } from 'store/slices/profile-api';
import { useGetUserTermsQuery } from 'store/slices/termsAndConditions-api';

const bundleRebalanceTerm = 'BUNDLE_REBALANCE';
export const useBundleRebalanceVisibility = (productCode?: string) => {
  const { product } = useProduct(productCode);
  const { data: userProfile } = useGetProfileQuery();
  const { data: termsAndConditions } = useGetUserTermsQuery();
  const countryCode = userProfile?.countryCode;

  if (!productCode) {
    return false;
  }

  const isBundle = product?.type == 'Bundle';
  const isSaCustomer = countryCode == 'ZA';
  const rebalanceTermIsActive =
    termsAndConditions?.find(t => t.code == bundleRebalanceTerm) ?? false;

  const hasNotAcceptedBundleTerms = !termsAndConditions?.find(
    t => t.code == bundleRebalanceTerm,
  )?.accepted;

  const showBundleRebalanceModal =
    isSaCustomer &&
    rebalanceTermIsActive &&
    hasNotAcceptedBundleTerms &&
    isBundle;

  return showBundleRebalanceModal;
};


export function useBundleRebalanceVisibilityPortfolio() {
  const { products } = useProductsWithHoldings();
  const { data: userProfile } = useGetProfileQuery();
  const { data: termsAndConditions } = useGetUserTermsQuery();
  const countryCode = userProfile?.countryCode;

  const holdsBundle = products?.some(p => p.totalAmount > 0 && p.type == 'Bundle');
  const isSaCustomer = countryCode == 'ZA';
  const rebalanceTermIsActive =
    termsAndConditions?.find(t => t.code == bundleRebalanceTerm) ?? false;

  const hasNotAcceptedBundleTerms = !termsAndConditions?.find(
    t => t.code == bundleRebalanceTerm,
  )?.accepted;

  const showBundleRebalanceModal =
    isSaCustomer &&
    rebalanceTermIsActive &&
    hasNotAcceptedBundleTerms &&
    holdsBundle;

  return showBundleRebalanceModal;
}